import React, { useState, useRef, useEffect } from 'react';
import { Box, Button, Grid, TextField, Typography, Avatar, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
import palette from 'src/theme/palette';
import LoadingButtonWrapper from 'src/components/LoadingButtonWrapper';
import InputField from 'src/components/InputField';
import { api } from 'src/Api';
import { toast } from 'react-toastify';
import GooglePlaces from 'src/components/GooglePlaces';

import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import DateFeild from 'src/components/DateFeild';

const Input = styled('input')({
  display: 'none'
});

export default function ProfileForm() {
  const inputRef = useRef();

  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user'));

  const [isSaveLoading, setSaveLoading] = useState(false);
  const [isSaveProfileLoading, setSaveProfileLoading] = useState(false);
  const [file, setfile] = useState({ image: user?.avatar, file: '' });

  const [objAfter, setobjAfter] = useState({
    name: user?.name,
    file: false
  });
  console.log('Here is file for avatar', file);
  const [form, setForm] = useState({
    firstName: user?.firstname || '',
    lastName: user?.lastname || '',
    email: user?.email || '',
    contactNo: user?.contact_no || '',
    address: user?.location || '',
    country: user?.country || '',
    city: user?.city || '',
    state: user?.state || '',
    lat: user?.lat || '',
    lon: user?.lon || '',
    dob: user?.dob || ''
  });

  // useEffect(() => {
  //   if (file?.file) {
  //     handleChangeProfile();
  //   }
  // }, [file]);

  const handleTextChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Google place handler
  const handlePlaceSelect = (val) => {
    setForm((prev) => ({
      ...prev,
      address: val?.address,
      country: val?.country,
      city: val?.city,
      state: val?.state,
      lat: val?.lat,
      lon: val?.lon
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const allowedTypes = ['image/jpeg', 'image/png'];
    // const maxSize = 1024 * 1024; // 1 MB

    if (!allowedTypes.includes(file.type)) {
      toast.error('Only JPG and PNG files are allowed.');
      return;
    }

    // if (file.size > maxSize) {
    //   toast.error('File size should be less than or equal to 1 MB.');
    //   return;
    // }

    setobjAfter({ file: true });
    setfile({
      image: URL.createObjectURL(file),
      file: file
    });
  };

  const handleButtonClick = () => {
    inputRef.current.click();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleEditProfile();
  };

  const handleEditProfile = () => {
    setSaveLoading(true);

    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('firstname', form.firstName);
    formData.append('lastname', form.lastName);
    form.contactNo && form.contactNo != undefined && formData.append('contact_no', form.contactNo);
    formData.append('location', form.address);
    formData.append('country', form.country);
    formData.append('city', form.city);
    formData.append('lat', form.lat);
    formData.append('lon', form.lon);
    formData.append('state', form.state);
    formData.append('dob', form.dob);

    // Add avatar to the same API call
    if (file && file.file) {
      formData.append('avatar', file.file);
    }

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    };

    fetch(api.update_profile, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          toast.success(result.message);
          localStorage.setItem('user', JSON.stringify(result?.data));
        } else {
          toast.error(result.error);
        }
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setSaveLoading(false);
      });
  };

  // const handleChangeProfile = () => {
  //   setSaveProfileLoading(true);

  //   const myHeaders = new Headers();
  //   myHeaders.append('Authorization', `Bearer ${token}`);

  //   const formData = new FormData();
  //   if (file && file.file) {
  //     formData.append('avatar', file.file);
  //   }

  //   const requestOptions = {
  //     method: 'POST',
  //     headers: myHeaders,
  //     body: formData,
  //     redirect: 'follow'
  //   };

  //   fetch(api.update_profile_picture, requestOptions)
  //     .then((response) =>
  //       response.text().then((result) => ({ status: response.status, body: result }))
  //     )
  //     .then(({ status, body }) => {
  //       const result = JSON.parse(body);
  //       if (status === 200 || status === 201) {
  //         toast.success(result.message);
  //         localStorage.setItem('user', JSON.stringify(result?.data));
  //         window.location.reload();
  //       } else {
  //         toast.error(result.error);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log('error', error);
  //     })
  //     .finally(() => {
  //       setSaveProfileLoading(false);
  //     });
  // };

  return (
    <Box
      sx={{
        px: { xs: 3.5, sm: 3.5 },
        pt: { xs: 1, sm: 3 }
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <Typography
            sx={{ fontSize: 15, fontFamily: 'poppinsBold', color: palette.primary.titledark }}
          >
            Personal Information
          </Typography>
          <Typography
            sx={{ fontSize: 12, fontFamily: 'poppinsRegular', color: palette.primary.title }}
          >
            Use a permanent address where you can receive mail.
          </Typography>
        </Grid>

        <Grid item xs={12} md={8} sx={{ ml: { xs: 0, sm: 3 } }}>
          <form onSubmit={handleSubmit}>
            <Stack
              sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 4 }}
            >
              <Avatar
                // src={objAfter?.file ? file.image : file.image + `?v='${Date.now()}`}
                src={file?.file ? URL.createObjectURL(file.file) : file?.image}
                sx={{ width: 72, height: 72, borderRadius: 0.7, objectFit: 'fill' }}
              />

              <Box sx={{ marginLeft: 3 }}>
                <Input
                  ref={inputRef}
                  type="file"
                  accept="image/jpeg, image/png"
                  onChange={handleImageChange}
                  style={{ display: 'none' }} // optional: hide the actual input
                />
                <LoadingButtonWrapper
                  loading={isSaveProfileLoading}
                  disabled={isSaveProfileLoading || isSaveLoading}
                  onClick={handleButtonClick}
                  // title="Change avatar"
                  title="Change profile pic"
                  style={{
                    width: isSaveProfileLoading ? 150 : 130,
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 5,
                    letterSpacing: 0.5,
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                    marginBottom: 0,
                    transition: 'width 0.3s ease, background-color 0.3s ease, transform 0.3s ease'
                  }}
                  height={30}
                  fontSize={10}
                  fontFamily={'poppinsLight'}
                />
                <Typography
                  sx={{
                    fontSize: 11,
                    color: palette.primary.title,
                    fontFamily: 'poppinsLight',
                    marginTop: 0.5
                  }}
                >
                  JPG or PNG.
                </Typography>
              </Box>
            </Stack>

            <Grid container>
              <Grid container spacing={{ xs: 0, sm: 2 }}>
                <Grid item xs={12} sm={6}>
                  <InputField
                    name="firstName"
                    label="First name"
                    type="text"
                    backgroundColor={'#ffffff'}
                    placeholder=""
                    value={form.firstName}
                    onChange={handleTextChange}
                    labelFontMedium
                    fontFamily={'poppinsRegular'}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputField
                    name="lastName"
                    label="Last Name"
                    type="text"
                    placeholder=""
                    backgroundColor={'#ffffff'}
                    value={form.lastName}
                    onChange={handleTextChange}
                    labelFontMedium
                    fontFamily={'poppinsRegular'}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <InputField
                  disabled
                  name="email"
                  label="Email"
                  type="text"
                  placeholder=""
                  backgroundColor={'#ffffff'}
                  value={form.email}
                  onChange={handleTextChange}
                  labelFontMedium
                  fontFamily={'poppinsRegular'}
                />
              </Grid>

              <Grid item xs={12}>
                <GooglePlaces
                  onResult={handlePlaceSelect}
                  address={form.address}
                  label="Location"
                  labelFontMedium
                  fontFamily={'poppinsRegular'}
                />
              </Grid>

              <Grid container spacing={{ xs: 0, sm: 2 }}>
                <Grid item xs={12} sm={6}>
                  <InputField
                    name="contactNo"
                    label="Contact No"
                    type="number"
                    placeholder=""
                    backgroundColor={'#ffffff'}
                    value={form.contactNo}
                    onChange={handleTextChange}
                    labelFontMedium
                    fontFamily={'poppinsRegular'}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DateFeild
                      label="Date of Birth"
                      name="dob"
                      value={form.dob}
                      onChange={handleTextChange}
                      labelFontMedium
                      fontFamily={'poppinsRegular'}
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>

              <Grid item xs={12}>
                <LoadingButtonWrapper
                  title="Save"
                  type="submit"
                  loading={isSaveLoading}
                  disabled={isSaveProfileLoading}
                  style={{
                    width: isSaveLoading ? 130 : 50,
                    paddingLeft: 10,
                    paddingRight: 10,
                    borderRadius: 5,
                    letterSpacing: 0.5,
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                    marginTop: 20,
                    marginBottom: 30,
                    transition: 'width 0.3s ease, background-color 0.3s ease, transform 0.3s ease'
                  }}
                  height={30}
                  fontSize={12}
                  fontFamily={'poppinsLight'}
                />
              </Grid>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Box>
  );
}
